import axios from "../../axios-instance";
import { getAdminBusinessId } from "../../utils/authHelper";

/**
 * get staff payments
 * @param {*} options
 * @returns
 */
export const getStaffPayments = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};
  axios
    .post(`admin/staff-payments/${getAdminBusinessId()}`, data)
    .then((res) => {
      if (onSuccess) {
        const { data } = res || {};
        onSuccess(data);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};

/**
 * get customer payments
 * @param {*} options
 * @returns
 */
export const getCustomerPayments = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};
  axios
    .post(`admin/customer-payments/${getAdminBusinessId()}`, data)
    .then((res) => {
      if (onSuccess) {
        const { data } = res || {};
        onSuccess(data);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};

/**
 * get event advanced page data
 * @param {*} options
 * @returns
 */
export const getCustomers = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};
  axios
    .post(`/admin/customers/${getAdminBusinessId()}`, data)
    .then((res) => {
      if (onSuccess) {
        const { data } = res || {};
        onSuccess(data);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};

/**
 * create customer
 * @param {*} options
 * @returns
 */
export const createCustomer = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};
  data.business_id = getAdminBusinessId();
  axios
    .post(`/admin/customer/create`, data)
    .then((res) => {
      if (onSuccess) {
        const { data } = res || {};
        onSuccess(data);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};

/**
 * delete customer
 * @param {*} options
 * @returns
 */
export const deleteCustomer = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};
  axios
    .post("/admin/customer/delete", data)
    .then((res) => {
      if (onSuccess) {
        const { data } = res || {};
        onSuccess(data);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};

/**
 * update customer
 * @param {*} options
 * @returns
 */
export const updateCustomer = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};
  axios
    .post("/admin/customer/update", data)
    .then((res) => {
      if (onSuccess) {
        const { data } = res || {};
        onSuccess(data);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};

/**
 * Get summary cards data for the Customers page header
 */
export const getCustomersSummary = (options) => async (dispatch) => {
  const { onSuccess, onError } = options || {};
  axios
    .get(`/admin/customers-summary/${getAdminBusinessId()}`)
    .then((res) => {
      if (onSuccess) onSuccess(res.data);
    })
    .catch((err) => {
      if (onError) onError(err);
    });
};

/**
 * Get full profile data for a single customer
 */
export const getCustomerProfile = (options) => async (dispatch) => {
  const { customerId, onSuccess, onError } = options || {};
  axios
    .get(`/admin/customer/profile/${customerId}/${getAdminBusinessId()}`)
    .then((res) => {
      if (onSuccess) onSuccess(res.data);
    })
    .catch((err) => {
      if (onError) onError(err);
    });
};

/**
 * Get booking history scoped to a single customer
 */
export const getCustomerBookings = (options) => async (dispatch) => {
  const { customerId, data, onSuccess, onError } = options || {};
  axios
    .post(`/admin/customer/bookings/${customerId}/${getAdminBusinessId()}`, data || {})
    .then((res) => {
      if (onSuccess) onSuccess(res.data);
    })
    .catch((err) => {
      if (onError) onError(err);
    });
};

/**
 * Get notes for a customer
 */
export const getCustomerNotes = (options) => async (dispatch) => {
  const { customerId, onSuccess, onError } = options || {};
  axios
    .get(`/admin/customer/notes/${customerId}/${getAdminBusinessId()}`)
    .then((res) => {
      if (onSuccess) onSuccess(res.data);
    })
    .catch((err) => {
      if (onError) onError(err);
    });
};

/**
 * Save a note for a customer
 */
export const saveCustomerNote = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};
  const payload = { ...data, business_id: getAdminBusinessId() };
  axios
    .post("/admin/customer/note/save", payload)
    .then((res) => {
      if (onSuccess) onSuccess(res.data);
    })
    .catch((err) => {
      if (onError) onError(err);
    });
};

/**
 * Delete a note
 */
export const deleteCustomerNote = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};
  axios
    .post("/admin/customer/note/delete", data)
    .then((res) => {
      if (onSuccess) onSuccess(res.data);
    })
    .catch((err) => {
      if (onError) onError(err);
    });
};

/**
 * Update a customer's status
 */
export const updateCustomerStatus = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};
  axios
    .post("/admin/customer/update-status", data)
    .then((res) => {
      if (onSuccess) onSuccess(res.data);
    })
    .catch((err) => {
      if (onError) onError(err);
    });
};

/**
 * Assign a staff member to a customer
 */
export const assignCustomerStaff = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};
  const payload = { ...data, business_id: getAdminBusinessId() };
  axios
    .post("/admin/customer/assign-staff", payload)
    .then((res) => {
      if (onSuccess) onSuccess(res.data);
    })
    .catch((err) => {
      if (onError) onError(err);
    });
};
